export default {
    install(Vue) {
        Vue.prototype.$toast = function(message) {
            this.$store.dispatch("Snackbar/showMessage", message);
        };
    },
};
